import { FC, memo } from "react"

export const Page404: FC = memo(() => {
  return (
    <>
      <h2>404ページです</h2>
    </>
  )
})
